import { Market, markets } from "./getMarkets";

const getPublishedMarkets = (): Market[] => {
  return markets.filter((market) => market.published);
};

export default getPublishedMarkets;
